import { useLocation } from 'react-router-dom'
import { getSeoMeta } from '../utils/seo.ts'

interface SeoH1Props {
  fallback?: string
  className?: string
}

export default function SeoH1({ fallback, className = 'text-3xl font-bold text-slate-900' }: SeoH1Props) {
  const location = useLocation()
  const path = location.pathname.replace(/\/$/, '') || '/'
  const meta = getSeoMeta(path)
  return <h1 className={className}>{meta.h1 || fallback}</h1>
}
